import { t } from 'ember-intl'
import { BaseSelect } from 'district-ui-client/components/base/select'
import { on } from '@ember/modifier'
import eventValue from 'district-ui-client/helpers/event-value'
import { eq } from 'ember-truth-helpers'
import Component from '@glimmer/component'

interface PageSizeSignature {
  Element: HTMLDivElement
  Args: {
    value: number
    onChange: (value: number) => void
  }
}

const PAGE_SIZES = [10, 25, 50, 100] as const

export class PageSize extends Component<PageSizeSignature> {
  onChange = (value: string) => {
    return this.args.onChange(Number(value))
  }

  <template>
    <label class="flex items-center gap-2 font-normal">
      <span class="text-sm text-neutral-250">{{t "base.pageSize.label"}}</span>
      <BaseSelect data-test-select-page-size {{on "input" (eventValue this.onChange)}}>
        {{#each PAGE_SIZES as |value|}}
          <option value="{{value}}" selected={{eq value @value}}>{{value}}</option>
        {{/each}}
      </BaseSelect>
    </label>
  </template>
}
